import { inject, Injectable } from '@angular/core';
import { RuleValueService } from '../rule-value/rule-value.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  readonly ruleValueService: RuleValueService = inject(RuleValueService);
  constructor() {}

  isCreditCardValidationEnabled(): boolean {
    return this.ruleValueService.getAuthorizeNetValidationMode() === 'liveMode';
  }
}
